import { SignInResponse, SignInSuccess } from "../types";

export function isAuthSuccess(
  response: SignInResponse
): response is SignInSuccess {
  return response.status === "success";
}
